import { FC, ComponentProps, MutableRefObject } from 'react';

import { isClosed } from 'utils/booking';
import { i18n as I18n } from 'utils/i18n';
import BookingSlots from '../bookingSlots';
import Slots from './slots';
import ClosedSlot from './closedSlot';

interface OpeningTimes {
  [key: string]: string;
}

interface Closure {
  startDate: string;
  endDate: string;
}

interface Space {
  id: number;
  openingTimes: OpeningTimes;
  priceIncVat: number;
  clinical: boolean;
}

interface Venue {
  openingTimes: OpeningTimes;
  closures: Closure[];
}

interface BookingItem {
  id: number;
}

interface Props {
  date: string;
  clinical?: boolean;
  venue: Venue;
  space: Space;
  times: any;
  startTime: string;
  endTime: string;
  slots?: ComponentProps<typeof BookingSlots>['slots'];
  bookingItems?: BookingItem[];
  scrollRef: MutableRefObject<{}>;
  availability: any;
  loading?: boolean;
  disabled?: boolean;
  onChange?: (value: any) => void;
  setTouched?: (value: boolean) => void;
}

const emptyList = [];

const SlotSelection: FC<Props> = ({
  date,
  venue,
  space,
  clinical = space.clinical,
  times,
  startTime,
  endTime,
  slots = emptyList,
  scrollRef,
  availability = {},
  loading = false,
  ...props
}) => {
  if (loading) return null;

  if (
    !startTime ||
    !endTime ||
    isClosed(date, venue.openingTimes, venue.closures) ||
    isClosed(date, space.openingTimes)
  )
    return <ClosedSlot length={times.length || undefined} />;

  if (clinical && slots.length === 0)
    return (
      <ClosedSlot
        length={times.length || undefined}
        label={I18n.t('quick_book.timeslot_widget.unavailable')}
      />
    );

  return clinical ? (
    <BookingSlots
      {...props}
      slots={slots}
      showSlotTimes={false}
      availability={availability}
      spaces={[space]}
      openingTime={startTime}
      horizontal
      relativeSizeAndPosition
    />
  ) : (
    <Slots
      {...props}
      date={date}
      startTime={startTime}
      endTime={endTime}
      availability={availability}
      scale={2}
      times={times}
      horizontal
      scrollRef={scrollRef}
    />
  );
};

export default SlotSelection;
